import { featureDefinitions } from './definitions.mjs';

function loadFeatures(features) {
    for (const key in features) {
        featureDefinitions[key] = {
            ...featureDefinitions[key],
            ...features[key],
        };
    }
}

export { loadFeatures };
